import { createFileRoute } from "@tanstack/react-router";

import { ReceiptPage } from "../../../../features/purchasing/receipt-page";

export const Route = createFileRoute("/_app/purchasing/receipts/$id")({ component: Page });

function Page() {
  const { id } = Route.useParams();
  return <ReceiptPage key={id} id={id} />;
}
